import { ByUserWithPositionRow, LeaderboardRow } from "./api";

export function isLeaderboardRowList(
  list: ByUserWithPositionRow[] | LeaderboardRow[],
): list is LeaderboardRow[] {
  return (list as LeaderboardRow[])[0].score !== undefined;
}
